import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const PermissionWrapper = ({ 
    children, 
    requiredPermission, 
    requiredPermissions, 
    requireAll = false,
    fallback = null 
}) => {
    const { hasPermission, hasAnyPermission, profile } = useAuth();

    // If profile is not loaded yet, don't render anything
    if (!profile) {
        return fallback;
    }

    // If a single permission is required
    if (requiredPermission) {
        return hasPermission(requiredPermission) ? children : fallback;
    }

    // If multiple permissions are provided
    if (requiredPermissions && Array.isArray(requiredPermissions)) {
        if (requireAll) {
            // User must have ALL permissions
            const hasAllPermissions = requiredPermissions.every(permission => 
                hasPermission(permission)
            );
            return hasAllPermissions ? children : fallback;
        } else {
            // User must have ANY of the permissions
            return hasAnyPermission(requiredPermissions) ? children : fallback;
        }
    }

    // If no permissions specified, render children
    return children;
};

export default PermissionWrapper; 